export const SET_STEP = 'SET_STEP'
export const SET_VISITED_STEP = 'SET_VISITED_STEP'
export const RESET_VISITED_STEP = 'RESET_VISITED_STEP'
export const SET_DECODED_VIN = 'SET_DECODED_VIN'
export const SET_VEHICLE = 'SET_VEHICLE'
export const RESET_SUBMODELS = 'RESET_SUBMODELS'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const SET_SELECTED_CHECKLIST_ITEMS = 'SET_SELECTED_CHECKLIST_ITEMS'

export const SET_SCANPRO_CONFIGURATION = 'SET_SCANPRO_CONFIGURATION'
export const SET_SCANPRO_CHECKLIST = 'SET_SCANPRO_CHECKLIST'
export const SET_SCANPRO_CRITERIA = 'SET_SCANPRO_CRITERIA'



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/types.js